import { useContext } from 'react'
import { AppContext, AppContextType } from '../AppContext'
import useUserContextRef from '../services/useUserContextRef'
import { wsConnection } from '../services/WSConnectionInstance'
import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'
import StatusErrorIcon from '../CustomIcons/StatusErrorIcon'
import { DialogBody } from './Dialog'
import DialogActionButtonsSection from '@/dialogs/components/DialogActionButtonsSection'

export function TooManyHostedSessionsErrorModal() {
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType
    const { userStateRef } = useUserContextRef()
    const show = !!appState.appState.showTooManyHostedSessionsDialog
    const isHost = appState.appState.showTooManyHostedSessionsDialog?.isHost ?? false

    const handleClose = () => {
        appDispatch({
            type: 'update_app_state',
            value: { showTooManyHostedSessionsDialog: null },
        })
    }

    const handleEndSessions = () => {
        wsConnection.sendMessage({
            type: 'end-all-sessions',
            data: {
                authToken: userStateRef.current.authToken,
                sessionId: userStateRef.current.sessionId,
            },
        })
        appDispatch({
            type: 'update_app_state',
            value: { showTooManyHostedSessionsDialog: null },
        })
    }

    const message = isHost
        ? 'You have too many active sessions. Please end your other sessions before starting a new one.'
        : 'The host has too many active sessions. Please ask them to end their current session before starting a new one.'

    if (!show) {
        return null
    }

    return (
        <CrossPlatformDialog frameName={`Dialog:tooManyHostedSessions`} onDefaultClose={handleClose}>
            <DialogBody>
                <h2 className="text-xl pb-4 flex items-center gap-2">
                    <StatusErrorIcon />
                    Error
                </h2>

                <div>{message}</div>
            </DialogBody>

            <DialogActionButtonsSection
                leftButtonText={isHost ? 'End all sessions' : undefined}
                rightButtonText="OK"
                onLeftButtonClicked={handleEndSessions}
                onRightButtonClicked={handleClose}
            />
        </CrossPlatformDialog>
    )
}
